import type { FreelancerDocumentsInformationPageLocales } from '../types';

const freelancerDocumentsInformationPageLocales: FreelancerDocumentsInformationPageLocales =
  {
    helperMessage:
      'The following video tells you more about the steps you have to go through before you can start freelancing through Tadaah.',
    preferToreadInstructions: 'Prefer to read the instructions?',
    startDocs: 'Start Documents',
    thenClickHere: 'Then click here',
    title: 'Documents',
  };

export default freelancerDocumentsInformationPageLocales;
